import React, { useEffect, useState } from "react";
import { AppBar, Tabs, Tab, Box, Typography, Paper } from "@mui/material";
import ReportSelector2 from "./ReportSelector2";
import ImageTable from "./ImageTable";
import ImageTable2 from "./ImageTable2";
import KYCReports from "./KYCReports";
import PoliceVerification from "./PoliceVerification";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const ThreeTabs = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="KYC" />
          <Tab label="POLICE" />
          {/* <Tab label="OTHERS" /> */}
        </Tabs>
      </AppBar>
      <Paper variant="outlined" sx={{ p: 0, mt: 1 }}>
        <TabPanel value={value} index={0}>
          <KYCReports />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PoliceVerification />
        </TabPanel>
        {/* <TabPanel value={value} index={2}>
          <Typography variant="body1">Tab 3 Content</Typography>
        </TabPanel> */}
      </Paper>
    </Box>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default ThreeTabs;

// import React, { useState } from "react";
// import { AppBar, Tabs, Tab, Box, Typography } from "@mui/material";

// const ThreeTabs = () => {
//   const [value, setValue] = useState(0);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   return (
//     <Box sx={{ width: "100%" }}>
//       <AppBar position="static">
//         <Tabs value={value} onChange={handleChange} centered>
//           <Tab label="KYC" />
//           <Tab label="POLICE" />
//           <Tab label="OTHERS" />
//         </Tabs>
//       </AppBar>
//       <TabPanel value={value} index={0}>
//         <Typography paragraph>KYC</Typography>
//       </TabPanel>
//       <TabPanel value={value} index={1}>
//         <Typography paragraph>POLICE</Typography>
//       </TabPanel>
//       <TabPanel value={value} index={2}>
//         <Typography paragraph>OTHERS</Typography>
//       </TabPanel>
//     </Box>
//   );
// };

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`tabpanel-${index}`}
//       aria-labelledby={`tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// export default ThreeTabs;
